import Vue from 'vue';
import moment from 'moment';

export default {
    namespaced: true,

    state: {
        settings: null,
        config: null,
        filters: {},
    },

    mutations: {
        setSettings(state, settings) {
            state.settings = settings;
        },

        setConfig(state, config) {
            state.config = config;
        },

        setFilters(state, filters) {
            state.filters = filters;
        },
    },

    getters: {
        getSettings(state) {
            return state.settings;
        },

        getSetting(state) {
            return (key, default_value) => state.settings.hasOwnProperty(key) ? state.settings[key] : default_value;
        },

        getConfig(state) {
            return state.config;
        },

        getFilters(state) {
            return state.filters;
        },

        isApplicationOpen(state) {
            return state.settings
                && moment(state.settings.application_start, 'MM-DD').isSameOrBefore(new Date(), "day")
                && moment(state.settings.application_end, 'MM-DD').isSameOrAfter(new Date(), "day");
        },

        openReportSubmissionPeriod(state) {
            if (!state.settings) {
                return false;
            }
            if (moment(state.settings.report_period_1_start, 'MM-DD').isSameOrBefore(new Date(), "day") && moment(state.settings.report_period_1_end, "MM-DD").isAfter(new Date(), "day")) {
                return 1;
            } else if (moment(state.settings.report_period_2_start, 'MM-DD').isSameOrBefore(new Date(), "day") && moment(state.settings.report_period_2_end, "MM-DD").isAfter(new Date(), "day")) {
                return 2;
            }
            return false;
        },

        getSemesterHalfYear(state) {
            if (!state.settings) {
                return null;
            }
            return (moment(state.settings.semester_start_1, 'MM-DD').isAfter(new Date(), "day") && moment(state.settings.semester_start_2, 'MM-DD').isBefore(new Date(), "day")) ? 2: 1;
        },
    },

    actions: {
        async fetchConfig({state, commit}) {
            if (!state.config) {
                let data = await Vue.$api.get('/settings/config');
                commit('setConfig', data);
            }
        },

        async save({commit}, value) {
            let data = await Vue.$api.post('/settings', value);
            commit('setSettings', data);
        },
    },

};